export const defaultProps = {
  lat: 22.27544,
  lng: 114.18873,
  zoom: 14,
};
